export default __webpack_public_path__ + "5939096dfcd964550a67bc1b8a3045f1.svg";